const FieldCellMixins = {
  props: {
    field: {
      type: Object
    },
    entries: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },

  computed: {
    hasValue: function() {
      return this.entries.length > 0;
    },

    entry: function() {
      return this.entries[0];
    },

    text_value: function() {
      return _.pluck(this.entries, 'value').join(', ') || '';
    }
  }
};

const HeaderFieldCellMixins = {
  props: {
    field: {
      type: Object
    },
    filter: {
      type: Object,
      default: function() {
        return {};
      }
    },
    order: {
      type: Object,
      default: function() {
        return {
          value: '',
          field: null
        };
      }
    },
    hasSort: {
      type: Boolean,
      default: true
    }
  },

  data: function() {
    return {
      keyword: '',
      sorter: '',
      sortable: ['asc', 'desc']
    };
  },

  created: function() {
    this.reset();
  },

  methods: {
    getFilter: function() {
      return this.keyword;
    },

    updateFilter: function() {
      this.$emit('filterChanged', true);
    },

    reset: function() {
      this.resetFilter();
      this.sorter = this.order.value;
    },

    resetFilter: function() {
      this.keyword = this.filter?.value || '';
    },

    toggleSort: function(sorter) {
      if (sorter === this.sorter) {
        this.sorter = '';
      } else {
        this.sorter = sorter;
      }
      this.$emit('orderChanged', this.sorter);
    }
  }
};

const HeaderRangeFieldCellMixins = {
  data: function() {
    return {
      start: null,
      end: null
    };
  },

  methods: {
    getFilter: function() {
      if (!(this.start || this.end)) {
        return null;
      }
      return {
        lft: this._stringfy(this.start),
        rgt: this._stringfy(this.end)
      };
    },

    resetFilter: function() {
      this.start = this.filter.value?.lft ? this._parseValue(this.filter.value.lft) : null;
      this.end = this.filter.value?.rgt ? this._parseValue(this.filter.value.rgt) : null;
    },

    updateStart: function(value) {
      this.start = value;
      this._emitChange();
    },

    updateEnd: function(value) {
      this.end = value;
      this._emitChange();
    },

    _emitChange: function() {
      this.$emit('filterChanged', false);
    },

    _stringfy: function(value) {
      return value;
    },

    _parseValue: function(str) {
      return str;
    }
  }
};

export { FieldCellMixins, HeaderFieldCellMixins, HeaderRangeFieldCellMixins };
